var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.398188 12.3824V0.582446H2.88619V11.6384L1.76619 10.3584H7.27819V12.3824H0.398188ZM11.6437 12.3824H9.15569V0.582446H13.1957C14.097 0.582446 14.8677 0.758446 15.5077 1.11045C16.153 1.45711 16.6437 1.92911 16.9797 2.52645C17.321 3.11845 17.4917 3.78778 17.4917 4.53445C17.4917 5.27578 17.3184 5.95578 16.9717 6.57445C16.6304 7.18778 16.1397 7.68111 15.4997 8.05445C14.8597 8.42245 14.0917 8.60645 13.1957 8.60645H11.6437V12.3824ZM11.6437 7.83845L10.5237 6.68645H12.9317C13.3477 6.68645 13.7104 6.60378 14.0197 6.43845C14.329 6.26778 14.569 6.02245 14.7397 5.70245C14.9104 5.37711 14.9957 4.98778 14.9957 4.53445C14.9957 4.07578 14.9104 3.69711 14.7397 3.39845C14.5744 3.09445 14.337 2.87045 14.0277 2.72645C13.7237 2.57711 13.3584 2.50245 12.9317 2.50245H10.5237L11.6437 1.31845V7.83845Z",
    fill: "#050505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLp);
export default __webpack_public_path__ + "static/media/LP.ed9edf1c7f1fcc0c9d70fa46b730a445.svg";
export { ForwardRef as ReactComponent };